import { Component, OnInit, Input } from '@angular/core';
import { Product } from '../services/product';
import { SafeUrl, DomSanitizer } from '@angular/platform-browser';
import { ProductsService } from '../services/products.service';

@Component({
  selector: 'app-product-mobile',
  templateUrl: './product-mobile.component.html',
  styleUrls: ['./product-mobile.component.scss']
})
export class ProductMobileComponent {
  private _product: Product

  @Input() set product(value: Product) {
    this._product = value
    if (value.videoUrl) {
      this.videoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
        "https://www.youtube.com/embed/" + value.videoUrl
        + '?autoplay=1&mute=1&loop=1&controls=0&playlist=' + value.videoUrl)
    }
  }

  get product() { return this._product }

  public videoUrl?: SafeUrl

  constructor(private sanitizer: DomSanitizer) { }
}
